export enum EscriptValidationIssueField {
  DAYS_SUPPLY = 'medicationPrescribed.daysSupply',
  PRODUCT_CODE = 'medicationPrescribed.drugCoded.productCode.code',
  PRESCRIBED_QUANTITY = 'medicationPrescribed.quantity.value',
  QUANTITY_UNIT_OF_MEASURE = 'medicationPrescribed.quantity.quantityUnitOfMeasure.code',
  SIGNATURE = 'medicationPrescribed.sig',
  NOTE = 'medicationPrescribed.note',
  PATIENT_PHONE = 'patient.communicationNumbers.phone.number',
}

export enum RxValidationIssueField {
  DAYS_SUPPLY = 'prescribed days supply',
  PRODUCT_CODE = 'prescribed ndc',
  PRESCRIBED_QUANTITY = 'quantity',
  QUANTITY_UNIT_OF_MEASURE = 'quantityUnitOfMeasure',
  SIGNATURE = 'signature',
  NOTE = 'note',
  DRUG_DESCRIPTION = 'drugDescription',
}

export const EscriptValidationIssueFieldToRxField = {
  [EscriptValidationIssueField.DAYS_SUPPLY]: RxValidationIssueField.DAYS_SUPPLY,
  [EscriptValidationIssueField.PRODUCT_CODE]: RxValidationIssueField.PRODUCT_CODE,
  [EscriptValidationIssueField.PRESCRIBED_QUANTITY]: RxValidationIssueField.PRESCRIBED_QUANTITY,
  [EscriptValidationIssueField.QUANTITY_UNIT_OF_MEASURE]: RxValidationIssueField.QUANTITY_UNIT_OF_MEASURE,
  [EscriptValidationIssueField.SIGNATURE]: RxValidationIssueField.SIGNATURE,
  [EscriptValidationIssueField.NOTE]: RxValidationIssueField.NOTE,
}
